import { useEffect } from 'react';
import { QueryResult } from '@apollo/client';
import { singletonHook } from 'react-singleton-hook';
import { GraphQLLeaseDocumentObjectType } from 'types/documents-types';
import { useLandaApiLazyQuery } from '../../../api/graphql/landa_api';
import { OptionsType } from '../../../api/graphql/functions/useLandaLazyQuery';
import { useUserDocumentsStore } from 'stores/UserDocuments/financialIdentities';
import { USER_LEASES_QUERY } from '../../../../graphql/account/queries/userLeasesQuery';
import useUserDetails from './useUserDetails';

const init: {
  request?: ((innerConfig?: OptionsType) => Promise<QueryResult>) | undefined;
  loading: boolean;
  userLeasesDocuments?: GraphQLLeaseDocumentObjectType[];
} = {
  userLeasesDocuments: [],
  request: undefined,
  loading: false,
};

const useUserLeases = () => {
  const { isTenant } = useUserDetails();
  const { userLeasesDocuments, setLeasesDocuments } = useUserDocumentsStore();
  const [fetchUserDocuments, { loading }] = useLandaApiLazyQuery(
    USER_LEASES_QUERY,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const initialize = () => {
    fetchUserDocuments({
      variables: { first: 100, after: 0 },
      onCompleted: (data) => {
        if (data?.resident?.leases?.edges.length > 0) {
          const leaseDocuments = data.resident.leases.edges.map(
            (edge: { node: GraphQLLeaseDocumentObjectType }) => edge.node
          );
          setLeasesDocuments(leaseDocuments);
        } else {
          setLeasesDocuments([]);
        }
      },
    });
  };

  useEffect(() => {
    if (!isTenant) return;
    initialize();
  }, [isTenant]);

  return {
    request: fetchUserDocuments,
    loading: loading,
    userLeasesDocuments: userLeasesDocuments || [],
  };
};

export default singletonHook(init, useUserLeases);
